export default "__VITE_ASSET__A1KErnIe__"